import React, { memo, useCallback, useEffect, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { Header } from '../../components/Header';
import { ResetButton } from '../../components/ResetButton';
import { FormLayout } from '../../components/FormLayout';
import { TitleForm } from '../../components/TitleForm';
import { Content } from '../../components/Content';
import { getCountFilledFields, getEnrichedSchema, IEnrichmentObject } from '../../utils';
import {
  useGetDefaultValues,
  useAppDispatch,
  useComponentLayout,
  useDebounce,
  useFormAnalytics,
  useGetFormScheme,
} from '../../hooks';
import { IEFieldSource } from '../../types/calculator';
import { IFormState } from '../../types/calculator/form';

export const Form: React.FC = memo(() => {
  const dispatch = useAppDispatch();
  const layout = useComponentLayout();

  // должны получать с бека
  const banksOptions = [
    { label: 'Сбербанк', value: '1' },
    { label: 'Тинькофф', value: '2' },
  ] as IEFieldSource[];

  // должны получать с бека
  const regionsOptions = [
    { label: 'Москва', value: '1' },
    { label: 'Самара', value: '2' },
  ] as IEFieldSource[];

  // состояние которое отвечает за успешность сабмита формы
  // const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(false);

  const { logFormExitProductAnalytics, logFormResetProductAnalytics } = useFormAnalytics();
  const defaultValues = useGetDefaultValues();
  const formScheme = useGetFormScheme();

  // TODO: Тут нужно будет реализовать прокидывание события
  const debouncedFetch = useDebounce(({ payload, data }) => console.info('debounce', data, payload), 500);

  const reactHookForm = useForm<IFormState>({
    mode: 'onChange',
    shouldUnregister: true,
    defaultValues,
  });

  const {
    formState: { isValid },
    getValues,
    handleSubmit,
  } = reactHookForm;
  const formValues = getValues();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const defaultFieldCount = useMemo(() => getCountFilledFields(formValues), []);

  const scheme = useMemo(() => {
    const enrichmentObject: IEnrichmentObject = {
      ['payrollBank']: banksOptions,
      ['region']: regionsOptions,
    };

    return getEnrichedSchema(formScheme.elements, enrichmentObject);
  }, [regionsOptions, banksOptions, formScheme]);

  const handleSuccess = (data: IFormState) => {
    const payload = {};
    // const payload = prepareDataRequest(data);
    // dispatch(updateLastSubmittedFormData(payload));
    // dispatch(setSearchStatusLoading());
    debouncedFetch({ payload, data });
  };

  const onSubmit = handleSubmit(handleSuccess);

  const handleResetClick = useCallback(() => {
    // dispatch(resetSearchError());
    // logFormResetProductAnalytics();
    // setIsSubmitSuccessful(false);
  }, [dispatch, logFormResetProductAnalytics]);

  useEffect(() => {
    /* Сабмит формы, если все поля валидны и заполнены */
    if (isValid && defaultFieldCount < getCountFilledFields(formValues)) {
      console.info('Все обязательные поля формы валидны и заполнены');
      onSubmit().then(() => {
        // setIsSubmitSuccessful(true);
      });
    }
  }, [isValid, formValues, onSubmit, defaultFieldCount]);

  return (
    <FormProvider {...reactHookForm}>
      <Header
        onExitClick={logFormExitProductAnalytics}
        rightSlot={<ResetButton onClick={handleResetClick} defaultFieldCount={defaultFieldCount} />}
      ></Header>
      <FormLayout layout={layout}>
        <form>
          <TitleForm level={1}>Ипотечный калькулятор</TitleForm>
          <Content elements={scheme} data-testid="form-content" />
        </form>
      </FormLayout>
    </FormProvider>
  );
});

Form.displayName = 'Form';
